import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Input from '../Input/Input';
import styles from './index.module.scss';
import Header from './Header/Header';
import PhoneIcon from '../../icons/phone.svg';
import PersonIcon from '../../icons/person.svg';
import JobRequestSummary from '../JobRequestSummary/JobRequestSummary';
import { formatPhone, clearPhone } from '../../utils/phoneFormatter';

function Step5({
  getState, setState, size, state, current, data, byCategory, handleChange, handleClose
}) {
  const phone = formatPhone(getState('clientPhone', ''), true, true);
  const isPhoneValid = getState('isPhoneValid', true);
  const submitError = getState('submitError', false);
  const submitErrorMessage = getState('submitErrorMessage')
    || 'There was a problem submitting your request. Please try again.';

  useEffect(() => {
    setState('isPhoneValid', true);
  }, [phone]);

  return (
    <div className={styles.wrapper}>
      <Header current={current} size={size} occupation={data.occupation_name} business={data.business_name} handleClose={handleClose} />
      {submitError
          && (
            <div className={styles.error}>
              <p>{submitErrorMessage}</p>
            </div>
          )}
      <div className={styles.body}>
        <div className={styles.columnsWrapper}>
          <div className={styles.leftContent}>
            <p className={styles.title}>What is your contact information?</p>
            <Input
              label={'Your name'}
              icon={<PersonIcon />}
              name={'clientName'}
              value={getState('clientName', '')}
              onChange={handleChange}
            />
            <Input
              label={'Phone number'}
              icon={<PhoneIcon />}
              name={'clientPhone'}
              value={phone}
              onChange={(e) => {
                e.target.value = clearPhone(e.target.value);
                handleChange(e);
              }}
              hasError={!isPhoneValid}
              errorMsg={'Not a valid phone number'}
            />
          </div>
          <div className={styles.rightContent}>
            <p className={styles.title}>Requested service</p>
            <JobRequestSummary data={state} byCategory={byCategory} />
          </div>
        </div>
      </div>
    </div>
  );
}

Step5.propTypes = {
  data: PropTypes.shape({
    occupation_name: PropTypes.string,
    occupation_id: PropTypes.number,
    business_name: PropTypes.string,
  }),
  setState: PropTypes.func,
  getState: PropTypes.func,
  handleChange: PropTypes.func,
  state: PropTypes.object,
  byCategory: PropTypes.object,
  current: PropTypes.number,
  size: PropTypes.number,
  handleClose: PropTypes.func,
};

export default Step5;
